import{getCentury}from"./getCentury";export var startOfCentury=function(a){var b=getCentury(a);return 0===b?new Date("0000-01-01T00:00:00"):new Date(b,0,1,0,0,0,0)};
//# sourceMappingURL=startOfCentury.js.map